import React from 'react';
import { default as MainLogo } from '~/icons/logo.svg';
import { Link } from '~/shared/components';
import styles from './Logo.module.scss';

export type LogoProps = {
    /**
     * pass SVG Logo node example: <Logo children={<BasketIcon/>} description={'Go to basket'} />
     */
    children?: React.ReactNode;

    /**
     * Description of what the logo is and where it potentially leads to,
     * this is required for screen readers
     */
    description?: string;
};

export const Logo = ({ children = <MainLogo />, description }: LogoProps) => {
    return (
        <Link href="/" aria-label={description ?? 'Imerco'}>
            <div className={styles.logoContainer}>{children}</div>
        </Link>
    );
};
